<template>
  <div>
    <app-header />
    <router-view />
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '../../app/AppHeader.vue';
import AppFooter from '../../app/AppFooter.vue';
import 'src/plugins/socket-io';
export default {
  name: 'DashBoardCoreView',
  components: {
    AppHeader,
    AppFooter,
  },
  mounted () {
    this.requestNotificationPermission();
  },
  methods: {
    async requestNotificationPermission () {
      if ('Notification' in window) {
        await Notification.requestPermission();
        // const permission = await Notification.requestPermission();
        // if (permission === "granted") {
        //   console.log("🔔 Notification permission granted");
        // } else {
        //   console.warn("❌ Notification permission denied");
        // }
      }
    },
  },
};
</script>

<style scoped></style>
